import React from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import { AiBorderBox } from '@shared/components/AiBorderBox';
import { JoyAiV2 } from '@withjoy/joykit/icons';
import { useTranslation } from '@shared/core';
import { pxToRem } from '@withjoy/joykit/theme';
import type { AutoPopulationPollingStatus } from '@shared/utils/autoPopulation/useAutoPopulation.types';
import { ShimmerAnimation } from '@shared/components/ShimmerAnimation';

type StayAreasStatusProps = Readonly<{
  status: AutoPopulationPollingStatus;
  shouldShowTooltip: boolean;
}>;

export const StayAreasStatus: React.FC<StayAreasStatusProps> = ({ status, shouldShowTooltip }) => {
  const { tq } = useTranslation('stayAreasAdmin');

  if (!shouldShowTooltip && status !== 'PENDING') return null;

  return (
    <AiBorderBox
      padding={6}
      background="white"
      borderRadius={12}
    >
      <ShimmerAnimation enabled={status === 'PENDING'}>
        <Flex
          gap={3}
          alignItems="center"
        >
          <JoyAiV2 size={48} />
          <TextV2
            typographyVariant={'body1'}
            textAlign="left"
            fontSize={pxToRem(14)}
          >
            {status === 'PENDING'
              ? tq`Finding curated neighborhoods near your venue...`
              : tq`We found a few curated neighborhood suggestions near your venue. Add, remove and tweak them the way you want.`}
          </TextV2>
        </Flex>
      </ShimmerAnimation>
    </AiBorderBox>
  );
};
